import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "~/components/Button";
import { Modal } from "~/components/Modal";
import { patchEvaluationAtom } from "~/modules/evalutation/services";
import { demoStudentEvaluationsRoute } from "~/routes/routes";

import { studentEvaluationDemoContext } from "../../../..";

export const PromptModal: React.FC = () => {
	const navigate = useNavigate();
	const { data: evaluation } = useContext(studentEvaluationDemoContext);

	const handleNavigateOut = useCallback(() => {
		navigate(`/${demoStudentEvaluationsRoute}/agendamento`, { replace: true });
	}, [navigate]);

	const handleCloseModal = useCallback(() => {
		patchEvaluationAtom({ hasAerobicPrescription: true });
	}, []);

	return (
		<Modal visible={!evaluation?.hasAerobicPrescription}>
			<div className="flex flex-col gap-5">
				<h1 className="text-lg">Deseja prescrição aeróbica?</h1>
				<div className="flex gap-4 self-end">
					<Button mode="outlined" className="w-28" onClick={handleNavigateOut}>
						Não
					</Button>
					<Button className="w-28" onClick={handleCloseModal}>
						Sim
					</Button>
				</div>
			</div>
		</Modal>
	);
};
